var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "support-search-results" }, [
    _c("h2", [
      _vm._v("Searching for '" + _vm._s(decodeURI(_vm.queryString)) + "'")
    ]),
    _vm._v(" "),
    _vm.results.length > 0 && !_vm.fetchingData
      ? _c("p", { staticClass: "support-search-results__sub-header" }, [
          _vm._v(
            "\n    About " +
              _vm._s(_vm.searchInfo.formattedTotalResults) +
              " results (" +
              _vm._s(_vm.searchInfo.formattedSearchTime) +
              "\n    seconds)\n  "
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _vm.results.length === 0 && !_vm.fetchingData
      ? _c("div", [
          _c("p", { staticClass: "support-search-results__no-results" }, [
            _vm._v("No results found")
          ])
        ])
      : _c("div", [
          _c(
            "ul",
            { staticClass: "support-search-results__result-list" },
            _vm._l(_vm.results, function(item, index) {
              return _c("li", { key: index }, [
                _c("a", {
                  attrs: { target: "_blank", href: item.link },
                  domProps: { innerHTML: _vm._s(item.htmlTitle) }
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: { innerHTML: _vm._s(item.htmlFormattedUrl) }
                }),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(item.snippet))])
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("div", { staticClass: "support-search-results__pagination" }, [
            _c(
              "ul",
              _vm._l(_vm.paginationControls, function(control) {
                return _c(
                  "li",
                  {
                    key: control.index,
                    class: { active: control.index === _vm.currentPage },
                    on: {
                      click: function($event) {
                        return _vm.getResults(control.index)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(control.index) + "\n        "
                    )
                  ]
                )
              }),
              0
            )
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }